/**
 * configureStore.js - создание хранилища и добавления к нему усилителей
 * @module store/configureStore
 * @requires module:reducers/index
 * */

import {createStore, applyMiddleware} from 'redux'
import {createLogger} from 'redux-logger'
import thunk from 'redux-thunk'

import rootReducer from '../reducers'

export default function configureStore(initialState, ...middleware) {
    const logger = createLogger()
    const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(thunk, logger, ...middleware))
    
    if (module.hot) {
        module.hot.accept('../reducers', () => {
            const nextRootReducer = require('../reducers')
            store.replaceReducer(nextRootReducer)
        })
    }
    
    return store
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js